export class CollectionSummaryState {
    summaryData: CollectionSummaryData[];
    custodians: string[];
  }
  
  export class CollectionSummaryData {
    period: string;
    custodianData: CustodianCollectionData[];
  }
  
  export class CustodianCollectionData {
    name: string;
    count: number;
  }